import Modal from "/WebInterface/new-ui/modules/modal.js";
import {
  generateCustomForm,
  attachCustomFormTools,
} from "/WebInterface/new-ui/modules/custom-form/custom-form.js";
import { Confirm } from "/WebInterface/new-ui/modules/alert.js";
import Loader from "/WebInterface/new-ui/modules/loader/loader.js";
import { t } from "/WebInterface/new-ui/modules/localizations/localizations.js";
import { _$ } from "/WebInterface/new-ui/assets/js/utils/dom.js";
import bodyTemplate, {
  keyValueFormTemplate,
  keyValueFormWithoutLabelTemplate,
} from "./template.js";
import {
  getPreview,
  getCustomForm,
  setPreview,
} from "/WebInterface/new-ui/assets/js/utils/api/apis.js";
import { validate } from "/WebInterface/new-ui/assets/js/utils/validate.js";

const evaluateFormFields = (keyValueFormFields = []) => {
  let template = "";

  keyValueFormFields.forEach((field, index) => {
    const templateValues = {
      showAddIcon: index === keyValueFormFields.length - 1,
      key: field.key,
      value: field.value,
      index: `${index}`,
    };

    index === 0
      ? (template += keyValueFormTemplate(templateValues))
      : (template += keyValueFormWithoutLabelTemplate(templateValues));
  });

  return template;
};

const addInputChangeListenerToKeyValuePair = (keyValueFormFields = []) => {
  const valueTextAreas = _$(".set-meta-value-textarea").sel();
  const keyInputs = _$(".set-meta-key-input").sel();

  keyInputs.forEach((input) => {
    const parent = _$(input).attr("index");

    _$(input).on("change", (e) => {
      keyValueFormFields[parent].key = e.target.value;
    });
  });

  valueTextAreas.forEach((textarea) => {
    const parent = _$(textarea).attr("index");

    _$(textarea).on("change", (e) => {
      keyValueFormFields[parent].value = e.target.value;
    });
  });
};

export const initSetMetaProperty = (args) => {
  const noKeyValPairFields =
    args?.name?.indexOf("noKeyValPairFields:'false'") > 0 ? false : true;
  const { input, path: filePath } = args;

  const showCustomForm = (customForm) => {
    if (!customForm) return;
    const formName = customForm.name;

    const keyValueFormFields = [
      {
        key: "",
        value: "",
      },
    ];

    const customFormContent = customForm ? generateCustomForm(customForm) : "";

    const dialog = new Modal({
      title: "Set Meta Property",
      body: bodyTemplate({
        keyValueFormTemplate: evaluateFormFields(keyValueFormFields),
        customFormTemplate: customFormContent,
        noKeyValPairFields,
      }),
      uniqueId: "set-meta-property-modal",
      backdrop: false,
      movable: true,
      minWidth: "800px",
      minHeight: "500px",
      buttons: [
        {
          label: "save",
          close: false,
          classes: ["mr-3"],
          onClick: async () => {
            const setPreviewPromises = [];
            const customFormParent = _$(".custom-form-set-meta-property").el();

            if (customFormParent) {
              const validateFields = validate(customFormParent, false);
              if (validateFields.length > 0) return;

              const data = utils.serializeInputs(customFormParent);

              Object.entries(data).forEach(async ([key, value]) => {
                setPreviewPromises.push(
                  setPreview({
                    path: filePath,
                    object_type: "exif",
                    exif_key: key?.replace("meta_", ""),
                    exif_val: value,
                    form_id: input,
                  })
                );
              });
            }

            keyValueFormFields.forEach(async (field) => {
              setPreviewPromises.push(
                setPreview({
                  path: filePath,
                  object_type: "exif",
                  exif_key: field.key,
                  exif_val: field.value,
                  form_id: input,
                })
              );
            });

            const loading = new Loader({});

            try {
              await Promise.all(setPreviewPromises);
            } finally {
              dialog.hide(true);
              loading?.deleteLoader();
            }
          },
        },
      ],
    });

    addInputChangeListenerToKeyValuePair(keyValueFormFields);
    attachCustomFormTools(dialog.root, formName);

    _$("#modal_set-meta-property-modal").on("click", (e) => {
      const addButton = _$(".addNewKeyValuePairButton").sel();
      const removeButton = _$(".removeKeyValuePairButton").sel();

      const customFormContent = customForm
        ? generateCustomForm(customForm)
        : "";

      if (addButton.some((f) => f.contains(e.target))) {
        keyValueFormFields.push({
          key: "",
          value: "",
        });

        dialog.update({
          body: bodyTemplate({
            keyValueFormTemplate: evaluateFormFields(keyValueFormFields),
            customFormTemplate: customFormContent,
          }),
        });

        addInputChangeListenerToKeyValuePair(keyValueFormFields);
      }

      const fieldToRemove = removeButton.find((f) => f.contains(e.target));

      if (fieldToRemove) {
        const parent = _$(fieldToRemove).attr("index");

        Confirm({
          title: t("removeField"),
          body: t("areYouSureYouWantToRemoveSelectedField"),
          confirm: t("yesRemove"),
          cancel: t("cancel"),
          zIndex: "101",
          closable: true,
        }).then((res) => {
          if (res) {
            keyValueFormFields.splice(parent, 1);

            dialog.update({
              body: bodyTemplate({
                keyValueFormTemplate: evaluateFormFields(keyValueFormFields),
                customFormTemplate: customFormContent,
              }),
            });

            addInputChangeListenerToKeyValuePair(keyValueFormFields);
          }
        });
      }
    });
  };
  getPreview({
    path: filePath,
    object_type: "exif",
  })
    .then((resp) => {
      getCustomForm(input).then(showCustomForm).catch(showCustomForm);
    })
    .catch((error) => {
      getCustomForm(input).then(showCustomForm).catch(showCustomForm);
    });
};
